const Download = () => import('@/pages/ProjectManagement/Download.vue');
import oidc from '@/vue-oidc-client';

export default [
    {
        path: '/project-management/file/:type/:id/download',
        name: 'projectManagement.file.download',
        component: Download,
        props: true,
        meta: {
            authName: oidc.authName,
        },
    },
];
